import UseaAssignAccount from '@v2/domains/person/hooks/account/useAssignAccount.hook'
import UseaAssignLead from '@v2/domains/person/hooks/lead/useAssignLead.hook'
import UseaAssignSearch from '@v2/domains/person/hooks/search/useAssignSearch.hook'

import useRecordInformation from './useRecordInformation.hook'

const UseMergePersons = () => {
  const RecordInfomration = useRecordInformation()
  let CLEAR_STORE_FUNCTION: () => void | undefined

  switch (RecordInfomration.location) {
    case 'account':
      CLEAR_STORE_FUNCTION = UseaAssignAccount().handleClearStoreAccount
      break
    case 'lead':
      CLEAR_STORE_FUNCTION = UseaAssignLead().handleClearStoreLead
      break
    case 'search':
      CLEAR_STORE_FUNCTION = UseaAssignSearch().handleClearStoreSearch
      break
    default:
      break
  }

  const handleClearStore = () => {
    return CLEAR_STORE_FUNCTION && CLEAR_STORE_FUNCTION()
  }

  return { ...RecordInfomration, handleClearStore }
}

export default UseMergePersons
